<div class="panel">
  <div class="big-div">
    <span class="icon aprovado white"></span>
    <p class="text-white">A FICHA <span class="ficha-id">{{ proposta?.id }}</span> FOI FINALIZADA E ENVIADO PARA ANÁLISE.</p>
  </div>
  <div class="small-div">
    <span class="icon aguardando-analise"></span>
    <div>
      <p class="text-white"><strong>EM ANÁLISE DIRETA</strong></p>
    </div>
  </div>
</div>
<div class="panel panel-small">
  <form class="forms">
    <div class="form-group">
      <span class="icon loja"></span>
      <div class="inputs">
        <label for="produto">PRODUTO ESCOLHIDO</label>
        <p><small>CDC Loja</small></p>
      </div>
    </div>
  </form>
</div>
<div class="panel panel-small">
  <form class="forms">
    <div class="form-group">
      <span class="icon pessoa"></span>
      <div class="inputs">
        <label for="cliente">CLIENTE</label>
        <p><small> <span class="name">{{ nomeCliente }}</span> - CPF: {{ cpfCliente }}</small></p>
      </div>
    </div>
  </form>
</div>
<div class="panel panel-small">
  <form class="forms">
    <div class="form-group">
      <span class="icon ficha-finalizada-condicoes"></span>
      <div class="inputs">
        <label for="cliente">CONDIÇÕES</label>
        <p><small> {{proposta?.valorLiquido | currency:'BRL':'symbol':'1.2-2'}} em {{ proposta?.qtdeParcelas }} x de
            {{ proposta?.valorParcela | currency:'BRL':'symbol':'1.2-2'}} </small></p>
      </div>
    </div>
  </form>
</div>
<div class="standalone-text">
  <p>
    Agora é só aguardar os próximos passos!
  </p>
</div>
